import $ from "jquery";

const headingShop = () => {
  const init = () => {
    action();
  };

  const action = () => {
    const el = {
      filterTitle:
        '.wpf_item_wpf_cat .wpf_hierachy li .wpf_submenu li input[type="radio"]',
      filterTitleLabel:
        ".wpf_item_wpf_cat .wpf_hierachy li .wpf_submenu li label",
      pageTitle: ".mi-HeadingShop__Title",
      productCat: ".mi-ProductCategories--Shortcode__Item",
      filterCatTitle: ".wpf_item .wpf_hierachy li .wpf_submenu li label",
      filterCatMenu: ".wpf_item .wpf_hierachy",
    };

    let selectedValue = JSON.parse(localStorage.getItem("selectedValue")) || [];

    const defaultValue = "Alle producten";

    const filterTitleHandler = ($radio) => {
      const newVal = $radio.val();
      const value = newVal.replaceAll("-", " ");

      if ($radio.is(":checked")) {
        selectedValue = value;
      }

      localStorage.setItem("selectedValue", JSON.stringify(selectedValue));

      if (selectedValue.length === 0) {
        $(el.pageTitle).text(defaultValue);
      } else {
        $(el.pageTitle).text(selectedValue);
      }
    };

    const handlerCat = () => {
      $(el.filterTitle).each(function () {
        let checkedTitle = $(this).is(":checked");
        if (checkedTitle) {
          let newVal = $(this).val();
          selectedValue.push(newVal);
          const latestVal = newVal.replaceAll("-", " ");
          // localStorage.setItem("selectedValue", JSON.stringify(selectedValue));
          $(el.pageTitle).text(latestVal);
        }
      });
    };

    $(document).on("click", el.filterTitle, function () {
      filterTitleHandler($(this));
    });

    $(document).ready(function () {
      handlerCat();
    });

    $(window).on("beforeunload", function () {
      localStorage.removeItem("selectedValue");
    });

    // const headingShopText = $(".js-text--changed").text();
    // const replacedText = headingShopText.replace("-", " ");
    // // $(".js-text--changed").text(replacedText);
    // console.log(replacedText);
  };

  init();
};

try {
  headingShop();
} catch (error) {
  console.log(error);
}
